// Test IDs for landing page sections.
export const LANDING = {
	navHome: 'landing-nav-home',
	navSubjects: 'landing-nav-subjects',
	navAbout: 'landing-nav-about',
	navPricing: 'landing-nav-pricing',
	navTestimonials: 'landing-nav-testimonials',
	navBook: 'landing-nav-book',
	heroBookButton: 'landing-hero-book-button',
	heroLearnMoreButton: 'landing-hero-learn-more-button',
	subjectChemistry: 'landing-subject-chemistry',
	subjectPhysics: 'landing-subject-physics',
	subjectBiology: 'landing-subject-biology',
	subjectMaths: 'landing-subject-maths',
	pricingBookButton: 'landing-pricing-book-button',
	contactNameInput: 'landing-contact-name-input',
	contactEmailInput: 'landing-contact-email-input',
	contactMessageInput: 'landing-contact-message-input',
	contactSubmitButton: 'landing-contact-submit-button',
};

export const BOOKING = {
	subjectSelect: 'booking-subject-select',
	keyStageSelect: 'booking-key-stage-select',
	calendar: 'booking-calendar',
	timeSlot: 'booking-time-slot',
	studentNameInput: 'booking-student-name-input',
	parentNameInput: 'booking-parent-name-input',
	emailInput: 'booking-email-input',
	phoneInput: 'booking-phone-input',
	notesInput: 'booking-notes-input',
	submitButton: 'booking-submit-button',
	payNowButton: 'booking-pay-now-button',
	totalAmount: 'booking-total-amount',
	backButton: 'booking-back-button',
	stepIndicator: 'booking-step-indicator',
};

export const PAYMENT = {
	successContainer: 'payment-success-container',
	cancelContainer: 'payment-cancel-container',
	statusMessage: 'payment-status-message',
	returnHomeButton: 'payment-return-home-button',
	retryButton: 'payment-retry-button',
};
